import React from 'react';

import styles from './gallery-thumbnail.module.css';
import { cloudinaryUrl } from '@/utils/utils';
import clsx from 'clsx';
import { MissingImage, useBrokenImage } from '@/stories/atoms/MissingImage/MissingImage';

export interface GalleryThumbnailProps {
  image: string,
  alt?: string,
  isSelected: boolean,
  onClick: () => void
}

export const GalleryThumbnail = ({ image, alt = '', isSelected = false, onClick }: GalleryThumbnailProps)=> {
  const { broken, ref, onError } = useBrokenImage()

  return (
    <button type='button' onClick={onClick} className={styles.wrapper}>
      {broken ? <MissingImage className={clsx(styles.missing, isSelected && styles.selected)} variant='mini'/> : <img
        ref={ref}
        onError={onError}
        loading='lazy'
        src={cloudinaryUrl({src: image, width: 108, params: ['h_108']})}
        srcSet={`${cloudinaryUrl({src: image, width: 108, params: ['h_108']})} 1x, ${cloudinaryUrl({src: image, width: 216, params: ['h_216']})} 2x`}
        className={clsx(styles.image, isSelected && styles.selected)} width={108} height={108} alt={alt}/>}
    </button>
  )
};
